import './PlansScreen.css';

import React from 'react'

const PlansScreen = () => {
  return (
    <div> </div>
  )
}

export default PlansScreen;